import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=4f6f6b4d&scoped=true&"
import script from "./Employee.vue?vue&type=script&lang=js&"
export * from "./Employee.vue?vue&type=script&lang=js&"
import style0 from "./Employee.vue?vue&type=style&index=0&id=4f6f6b4d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6f6b4d",
  null
  
)

export default component.exports